"use client";

import { useTranslation } from "@/hooks/localization/useTranslations";

type props = {
  is_configurable: boolean;
};
const ProductStartFrom: React.FC<props> = ({ is_configurable }) => {
  const t = useTranslation();
  return (
    <div className="start-from">{is_configurable ? t.starts_from : ""}</div>
  );
};

export default ProductStartFrom;
